export enum InvoiceType {
    Invoice = 1,
    Credit = 2,
    Debit = 4,
}
